import {StateProvider} from "@uirouter/angularjs";
import {FeatureNames, UserConfigProvider} from "../types/UserConfig";
import {EquityAccountView} from "./equity/view/EquityAccountViewComponent";
import {AnalyticsType} from "../analytics/models/AnalyticsType";

/** @ngInject */
export function routerConfig($stateProvider: StateProvider, userConfigProvider: UserConfigProvider) {

    if (userConfigProvider.config.features[FeatureNames.SCREEN_OPTIONS_ACCOUNT]) {
        const newOptionsView = userConfigProvider.config.strategyBasedView;
        const templateUrl =  newOptionsView ? "app/portfolio/portfolioTO.tpl.html" : "app/portfolio/portfolio.tpl.html";

        $stateProvider.state("portfolio", {
            url: "/portfolio/{portfolioId:int}",
            templateUrl,
            controller: "portfolioCtrl as portfolioCtrl",
            params: {
                activeWhatIfId: null,
                activeStrategyId: null
            },
            data: {
                pageTitle: "Portfolio"
            },
            /** @ngInject */
            onEnter: (analyticsService) => analyticsService.submit(AnalyticsType.VISIT_PORTFOLIO),
            resolve: {
                widgetPrefs: ["userPrefsFactory", (userPrefsFactory: any) => userPrefsFactory("portfolio.widgets")]
            }
        });
    } else if (userConfigProvider.config.features[FeatureNames.SCREEN_EQUITY_ACCOUNT]) {
        // TODO add another condition to determine if equity or eto view
        $stateProvider.state("portfolio", {
            url: "/portfolio/{portfolioId:int}",
            component: EquityAccountView,
            data: {
                pageTitle: "Account"
            },
            /** @ngInject */
            onEnter: (analyticsService) => analyticsService.submit(AnalyticsType.VISIT_PORTFOLIO)
        });
    }
}
